import dayjs from 'dayjs'

// проверка, что дата меньше сегодняшней
export const checkIfDateLessToday = (
  date: string,
  compareValue = 0,
): boolean => {
  const today = dayjs().startOf('day')
  const diffDate = dayjs(date).startOf('day')
  return dayjs(diffDate).diff(today, 'day') > compareValue
}

// проверка, что дата меньше сегодняшней с учетом времненей
export const checkIfDateLessTodayWithTime = (
  date: string,
  compareValue = 0,
): boolean => {
  const today = dayjs()
  const diffDate = dayjs(date)

  return dayjs(diffDate).diff(today, 'seconds') > compareValue
}
